import { mergeStyles } from "@fluentui/merge-styles";

export const saveBtnClass = mergeStyles({
    width: '100%'
});

export const stackColumnGap10 = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const stackColumnGap20 = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
});

export const stackColumnGap10Pad20 = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  padding: 20,
});

export const paddingBottom10 = mergeStyles({
  paddingBottom: '10px',
});

export const followBtnClass = mergeStyles({
  width: '100%',
  marginBottom: 15,
});

export const iconImgClass = mergeStyles({
  height: '18px',
  width: '18px',
});

export const cardClass = mergeStyles({
  border: '1px solid #edebe9',
  boxShadow: '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)',
});
